import { Component, OnInit } from '@angular/core';
import { ReponseCoordonneesCredit } from '../../api/model/reponse-coordonnees-credit.model';
import { LangueService } from '../../services/langue/langue.service';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { NavigationService } from '../../services/navigation/navigation.service';
import { AdressePhysiqueCredit } from '../../api/model/adresse-physique-credit.model';
import { Anys } from '../../util/anys';
import { ParticulierCredit } from '../../api/model/particulier-credit.model';
import { ChangementCoordonneeCreditFiservAccesDService } from '../../services/changement-coordonnee-credit-fiserv-accesd/changement-coordonnee-credit-fiserv-acces-d.service';
import { GabaritService } from '../../services/gabarit/gabarit.service';
import { ReponseCoordonneesCreditService } from '../../services/reponse-coordonnees-credit/reponse-coordonnees-credit.service';
import { CybermetrieCoordonneesService } from '../../services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../models/cybermetrie/cybermetrie.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { GestionErreurService } from 'src/app/services/gestion-erreur/gestion-erreur.service';
import { ConfigMeta } from 'src/app/models/meta';
import { GestionTitreService } from '../../services/navigation/gestion-titre.service';

const URL_ADP = 'oel-adp-url';
@Component({
  selector: 'app-accueil-fiserv',
  templateUrl: './accueil-fiserv.component.html',
  styleUrls: ['./accueil-fiserv.component.scss'],
  standalone: false,
})
export class AccueilFiservComponent implements OnInit {
  reponseCoordonneesCredit: ReponseCoordonneesCredit;
  adressePostale: AdressePhysiqueCredit;
  telephonePrincipal: string;
  courrielUnique: string;
  titrePageCoordonneesCredit: string = 'caad.titre';
  messageAlerte: string = '';
  titreSectionCarteCredit: string = '';
  affichageAucunTelephonePrincipal: boolean = false;
  affichageAucuneAdresseCourriel: boolean = false;
  affichageAdresseCourrielIdentique: boolean = false;
  particuliersCreditPlusQueUn: boolean = false;
  isAppMobile: boolean;
  afficherPageAucuneCarteCredit: boolean = false;
  typeMessageErreur: string;
  codeErreur: string = '';

  constructor(
    private readonly langueService: LangueService,
    private readonly navigationService: NavigationService,
    protected readonly configService: ConfigurationService,
    private readonly coordonneesCreditService: ChangementCoordonneeCreditFiservAccesDService,
    private readonly gabaritService: GabaritService,
    private readonly reponseCoordonneesCreditService: ReponseCoordonneesCreditService,
    private readonly cybermetrieService: CybermetrieCoordonneesService,
    private readonly gestionErreurService: GestionErreurService,
    private readonly gestionTitreService: GestionTitreService
  ) {}

  ngOnInit(): void {
    this.isAppMobile = this.gabaritService.isAppMobile();
    this.typeMessageErreur = this.isAppMobile ? 'messageMobile' : 'message';
    this.coordonneesCreditService.obtenirCoordooneesCredit$().subscribe({
      next: (data) => {
        this.reponseCoordonneesCreditService.setReponseCoordonneesCredit(data);
        this.initialiserVariablesPageAccueil(data);
      },
      error: (err: HttpErrorResponse) => {
        this.codeErreur = this.gestionErreurService.getCodeErreur(err);
        if (this.gestionErreurService.doitAfficherPageAucuneCarteCredit(err)) {
          this.afficherPageAucuneCarteCredit = true;
          const messageErreur = new Map<string, string>();
          messageErreur.set(CybermetrieEnum.MESSAGE_ERREUR, CybermetrieEnum.AUCUNE_CARTE_CREDIT);
          this.cybermetrieService.envoyerEvenementPersonnalise(
            CybermetrieEnum.CATEGORIE_TRANSACTION,
            CybermetrieEnum.ACTION_EOF,
            CybermetrieEnum.LABEL_INFOS_TOTAL,
            null,
            null,
            messageErreur
          );
        } else {
          this.navigationService.naviguerVersPageErreurCredit(
            err.status.toString(),
            this.codeErreur,
            this.gestionErreurService.getMessageErreur(err)
          );
        }
      },
    });
  }

  private initialiserVariablesPageAccueil(data: ReponseCoordonneesCredit) {
    this.reponseCoordonneesCredit = data;
    this.particuliersCreditPlusQueUn = this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn();
    this.initialiserTitres();
    this.initialiserCoordonneesCredit();
    const extra = new Map<string, string>();
    if (this.particuliersCreditPlusQueUn) {
      extra.set(CybermetrieEnum.EXTRA_ATTRIBUT, CybermetrieEnum.PLUSIEURS_CARTES_CREDIT);
    } else {
      extra.set(CybermetrieEnum.EXTRA_ATTRIBUT, CybermetrieEnum.UNE_CARTE_CREDIT);
    }
    this.cybermetrieService.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_GESTION_CARTE,
      CybermetrieEnum.ACTION_AFFICHAGE,
      CybermetrieEnum.LABEL_MODIFIER_COORDONNEES,
      null,
      null,
      extra
    );
  }

  private initialiserCoordonneesCredit() {
    this.adressePostale = this.reponseCoordonneesCreditService.getAdresseCourante();
    this.telephonePrincipal = this.reponseCoordonneesCreditService.getTelephone().numeroTelephone;
    this.courrielUnique = this.reponseCoordonneesCreditService.getAdresseCourriel();
    this.affichageAucunTelephonePrincipal = Anys.isNullOrUndef(this.telephonePrincipal);
    this.affichageAucuneAdresseCourriel = this.afficherAucuneAdresseCourriel(
      this.reponseCoordonneesCredit.particulierCredit
    );
    this.affichageAdresseCourrielIdentique = this.estAdresseCourrielIdentique(
      this.reponseCoordonneesCredit.particulierCredit
    );
  }

  private initialiserTitres() {
    this.titrePageCoordonneesCredit = this.particuliersCreditPlusQueUn ? 'caad.titreMulticarte' : 'caad.titre';
    this.messageAlerte = this.particuliersCreditPlusQueUn
      ? 'caad.accueil.alerte.changementAppliqueSeulementMultiplesCartes'
      : 'caad.accueil.alerte.changementAppliqueSeulement';
    this.titreSectionCarteCredit = this.particuliersCreditPlusQueUn
      ? 'caad.accueil.titrePlusieursCartesLieesAuCompte'
      : 'caad.accueil.titreUneCarteLieeAuCompte';

    this.gestionTitreService.addTitreOnglet(
      this.particuliersCreditPlusQueUn
        ? 'caad.titreOnglet.accueilFiserv.titreMulticarte'
        : 'caad.titreOnglet.accueilFiserv.titre'
    );
  }

  allerVersPrecedent(): void {
    return this.configService.isConfigEqualValue(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF, 'true')
      ? this.navigationService.naviguerVersCoordonnees()
      : this.navigationService.naviguerVersUrlExterne(
          `${this.configService.getValueOrBlank(URL_ADP)}/dossier-personnel/liste-adresses`
        );
  }

  clicSurModifier(): void {
    this.navigationService.naviguerVersModificationCredit();
  }

  estBancaireActif(): boolean {
    return this.configService.isConfigEqualValue(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF, 'true');
  }

  private afficherAucuneAdresseCourriel(particuliersCredit: Array<ParticulierCredit>): boolean {
    return particuliersCredit?.every(
      (particulier) =>
        Anys.isNullOrUndef(particulier.adresseCourriel?.adresseCourriel) ||
        particulier.adresseCourriel.adresseCourriel.trim() === ''
    );
  }

  private estAdresseCourrielIdentique(particuliersCredit: Array<ParticulierCredit>): boolean {
    return particuliersCredit?.some(
      (particulier) => particulier.adresseCourriel?.indicateurAdresseCourrielIdentique === true
    );
  }
}
